/* eslint-disable @typescript-eslint/no-explicit-any */
import Button from '@components/Button/Button'

import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useEffect, useState } from 'react'
import styles from './Login.module.scss'
import { login } from '@/config/auth/services/authService'
import { HTTPInstance } from '@/http/http-instance'
import { useSnackbar } from '@/components/Snackbar/SnackbarProvider'
import OTPInput from '@/components/OtpInput/OtpInput'
import Keyboard from '@/components/Keyboard/Keyboard'

type Restaurant = { id: string | number; [k: string]: any }

function Login() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { showSnackbar } = useSnackbar()
  const [otp, setOtp] = useState('')

  const handleLogin = async (email: string, password: string) => {
    try {
      await login(email, password)

      const { data } = await HTTPInstance.get<Restaurant[]>('/restaurants')
      const restaurants = data ?? []

      if (restaurants.length > 0) {
        const { id } = restaurants[0]
        localStorage.setItem('restaurantId', String(id))
        navigate('/tables-list')
      } else {
        setOtp('')
      }
    } catch {
      setOtp('')
      showSnackbar?.(t('AUTHORIZATION.LOGIN.ERROR') || 'Login failed', 'error')
    }
  }

  const setOtpValue = (digit: number) => {
    if (otp.length < 6) {
      setOtp(prev => prev + digit.toString())
    }
  }

  const clearOtpValue = () => {
    setOtp('')
  }

  const deleteLastOtpDigit = () => {
    setOtp(prev => prev.slice(0, -1))
  }

  useEffect(() => {
    if (otp.length === 6) {
      handleLogin('waiter@test.com', otp)
    }
  }, [otp])

  return (
    <div className={`${styles.loginContainer}`}>
      <h1 className={`title-bold-medium ${styles.loginHeader}`}>
        {t('AUTHORIZATION.LOGIN')}
      </h1>
      <OTPInput setOtp={setOtp} otp={otp} />
      <Keyboard
        setValue={setOtpValue}
        clearValue={clearOtpValue}
        deleteValue={deleteLastOtpDigit}
      />
      <div className={`${styles.loginFormButtonContainer}`}>
        <Button
          form="login-form"
          onClick={() => navigate('/reset-pin')}
          label={t('AUTHORIZATION.LOGIN.FORGOT_PIN')}
          variant="contained"
          color="secondary"
          type="submit"
          maxWidth
          mobile
        />
      </div>
    </div>
  )
}

export default Login
